__turbopack_context__.v({
  "avatar": "ThemePackIntroMotion-module__ci_RNa__avatar",
  "avatarScale": "ThemePackIntroMotion-module__ci_RNa__avatarScale",
  "bubble": "ThemePackIntroMotion-module__ci_RNa__bubble",
  "bubbleOpacity": "ThemePackIntroMotion-module__ci_RNa__bubbleOpacity",
  "bubbleScale": "ThemePackIntroMotion-module__ci_RNa__bubbleScale",
  "bubbleText": "ThemePackIntroMotion-module__ci_RNa__bubbleText",
  "bubbleTranslate": "ThemePackIntroMotion-module__ci_RNa__bubbleTranslate",
});
